/**
 * Reordena productos en las páginas de colección para que los productos con stock
 * aparezcan primero y los sin stock al final
 */
(function() {
  'use strict';

  function checkProductHasStock(productCard) {
    // Verificar si el producto tiene stock disponible
    const available = productCard.getAttribute('data-product-available');
    if (available === 'true') {
      return true;
    }

    // Verificar también en el contenido del card si hay indicadores de stock
    const stockIndicator = productCard.querySelector('.stock-indicator');
    if (stockIndicator) {
      const stockText = stockIndicator.textContent || '';
      // Si dice "out of stock" o similar, no tiene stock
      if (stockText.toLowerCase().includes('out of stock') || 
          stockText.toLowerCase().includes('sin stock') ||
          stockText.toLowerCase().includes('agotado')) {
        return false;
      }
      // Si dice "in stock" o "en inventario", tiene stock
      if (stockText.toLowerCase().includes('in stock') || 
          stockText.toLowerCase().includes('en inventario')) {
        return true;
      }
    }

    // Verificar botones de compra deshabilitados
    const addToCartBtn = productCard.querySelector('button[type="submit"]');
    if (addToCartBtn && addToCartBtn.disabled) {
      return false;
    }

    // Por defecto, si no podemos determinar, asumimos que tiene stock
    return available !== 'false';
  }

  function reorderProductsByStock() {
    const productGrid = document.querySelector('#product-grid[data-reorder-by-stock="true"]');
    if (!productGrid) {
      return;
    }

    const productCards = Array.from(productGrid.querySelectorAll('.collection-product-card'));
    if (productCards.length === 0) {
      return;
    }

    // Separar productos con stock y sin stock
    const productsWithStock = [];
    const productsWithoutStock = [];

    productCards.forEach(card => {
      if (checkProductHasStock(card)) {
        productsWithStock.push(card);
      } else {
        productsWithoutStock.push(card);
      }
    });

    // Si todos tienen stock o todos no tienen stock, no hay nada que reordenar
    if (productsWithStock.length === 0 || productsWithoutStock.length === 0) {
      return;
    }

    // Reordenar: primero los con stock, luego los sin stock
    // Mantener el banner al final si existe
    const banner = productGrid.querySelector('.banner-fixed-position');
    
    // Remover todos los productos del grid
    productsWithStock.forEach(card => card.remove());
    productsWithoutStock.forEach(card => card.remove());

    // Agregar primero los productos con stock
    productsWithStock.forEach(card => {
      productGrid.appendChild(card);
    });

    // Luego los productos sin stock
    productsWithoutStock.forEach(card => {
      productGrid.appendChild(card);
    });

    // Si hay banner, mantenerlo al final
    if (banner) {
      productGrid.appendChild(banner);
    }
  }

  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reorderProductsByStock);
  } else {
    reorderProductsByStock();
  }

  // También ejecutar después de que se carguen más productos (load more, infinite scroll)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        // Esperar un poco para que los nuevos productos se rendericen completamente
        setTimeout(reorderProductsByStock, 100);
      }
    });
  });

  // Observar cambios en el product grid
  const productGrid = document.querySelector('#product-grid[data-reorder-by-stock="true"]');
  if (productGrid) {
    observer.observe(productGrid, {
      childList: true,
      subtree: true
    });
  }
})();

